import RoutesMap from 'route_control/RouteControl'
import { InOutBookList, InOutEntries, VisitorMonitoring, GateOperations, PreApprovedVisitorList,VisitorAndGatePass, VisitorApprovalRequestList, MyVisitorList, OverStayList, VisitorManagementSystem, DirectoryAndStaff } from 'pages/vms'

const VisitorRoute = () => {
    return [
        {
            path: RoutesMap.VISITOR_MONITORING.path,
            element: <VisitorMonitoring />,
        },
        {
            path: RoutesMap.GATE_OPERATIONS.path,
            element: <GateOperations />,
        },
        {
            path: RoutesMap.IN_OUT_BOOK.path,
            element: <InOutBookList />,
        },
        {
            path: RoutesMap.IN_OUT_DETAILS.path,
            // element: <InOutDetails />,
        },
        {
            path: RoutesMap.IN_OUT_ENTRIES.path,
            element: <InOutEntries />,
        },
        {
            path: RoutesMap.VISTOR_GATEPASS.path,
            element: <VisitorAndGatePass />,
        },
        {
            path: RoutesMap.PRE_APPROVED_VISITOR_LIST.path,
            element: <PreApprovedVisitorList />,
        },

        {
            path: RoutesMap.VISITOR_APPROVAL_REQUESTS_LIST.path,
            element: <VisitorApprovalRequestList />,
        },

        {
            path: RoutesMap.MY_VISITOR_LIST.path,
            element: <MyVisitorList />,
        },

        {
            path: RoutesMap.OVER_STAY_LIST.path,
            element: <OverStayList />,
        },
        {
            path: RoutesMap.VISITOR_MANAGEMENT_SYSTEM.path,
            element: <VisitorManagementSystem />,
        },
        {
            path: RoutesMap.DIRECTORY_AND_STAFF.path,
            element: <DirectoryAndStaff />,
        },
    ]
}

export default VisitorRoute;